import { acArrowLeft, acArrowRight } from 'ac-icon';
import React from 'react';
import Icon from '../icon/Icon';
import { MultiLink } from '../link/MultiLink';
import { COLORS } from '../colors';
const ButtonDirection = ({ id, href, text, direction, titleDirection, className }) => {
    const isLeftDirection = direction === 'left';
    const renderArrow = () => {
        return (React.createElement("div", { className: 'd-flex' },
            React.createElement(Icon, { path: isLeftDirection ? acArrowLeft : acArrowRight, title: titleDirection ? titleDirection[direction] : undefined, color: COLORS.primitiveNavyBlue, opacity: 0.88, size: '24px', className: isLeftDirection ? 'mr-x2' : 'ml-x2' })));
    };
    return (React.createElement(MultiLink, { id: id, href: href, className: 'button-direction ' + direction + ' ' + (className ? className : '') },
        isLeftDirection && renderArrow(),
        React.createElement("p", { className: 'bd-p mb-0' }, text),
        !isLeftDirection && renderArrow()));
};
export { ButtonDirection };
//# sourceMappingURL=ButtonDirection.js.map